<div class="page__loading" style="display: flex; justify-content: center; align-items: center; height: 100%">
  <img src="/assets/images/preloader.gif" alt="Loading..." />
</div>
